import React from "react";
import DOMPurify from "dompurify";

function ShowTextPopup({ title, data, onClick }) {
  // Security: sanitize HTML before injecting via dangerouslySetInnerHTML to prevent XSS.
  const cleanData = DOMPurify.sanitize(data || "", {
    ALLOWED_TAGS: ['br', 'p', 'b', 'i', 'em', 'strong', 'ul', 'ol', 'li', 'span', 'div', 'a', 'code', 'pre', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    ALLOWED_ATTR: ['class', 'href', 'title', 'target', 'rel', 'style'],
  });
  return (
    <>
      <div className="teacherviewcoursedetails-inner-popup-wrappper">
        <div className="teacherviewcoursedetails-inner-popup-folder">
          <h2>{title}</h2>
          <p
            className="Overview-Lesson-description"
            dangerouslySetInnerHTML={{ __html: cleanData }}
          />
          <span className="my-course-close-btn" onClick={onClick}>
            <i className="fa-solid fa-x"></i>
          </span>
        </div>
      </div>
    </>
  );
}

export default ShowTextPopup;
